import Vue from 'vue'
import Vuex from 'vuex'

//1.安装插件
Vue.use(Vuex)

Vue.use(Vuex);
//2.创建对象
const store = new Vuex.Store({
    state: {
        // fid: '',// 家谱id
        mid: '', // 成员id
        // relation: '', // 人员 1父母 2子女 3兄弟
        // memberType: '',// 人员添加编辑
        spouseData: [],// 配偶添加数据
        migrationData: [],//居住
        infoMemberData: { },// 基本信息
        sgztData:true,// 生故状态
        hyztData:true,// 婚姻状态
        pxm:'', // 父级姓名
        zxxs: '',// 祖先姓氏
        zxmz: '',// 祖先民族
        phData:[
            { key: '独', val: 0 },
            { key: '长', val: 1 },
            { key: '次', val: 2 },
            { key: '三', val: 3 },
            { key: '四', val: 4 },
            { key: '五', val: 5 },
            { key: '六', val: 6 },
            { key: '七', val: 7 },
            { key: '八', val: 8 },
            { key: '九', val: 9 },
            { key: '十', val: 10 },
            { key: '十一', val: 11 },
            { key: '十二', val: 12 },
            { key: '十三', val: 13 },
            { key: '十四', val: 14 },
            { key: '十五', val: 15 },
        ],
        mzData:["汉族","壮族","回族","维吾尔族","苗族","满族","彝族","土家族","藏族","蒙古族","布依族","侗族","瑶族","白族","哈尼族","朝鲜族","黎族","哈萨克族","傣族","畲族","东乡族","傈僳族","仡佬族","拉祜族","水族","佤族","纳西族","羌族","土族","仫佬族","柯尔克孜族","锡伯族","撒拉族","景颇族","达斡尔族","布朗族","毛南族","塔吉克族","普米族","阿昌族","怒族","鄂温克族","基诺族","保安族","德昂族","俄罗斯族","裕固族","乌孜别克族","门巴族","鄂伦春族","独龙族","赫哲族","珞巴族","高山族","塔塔尔族"],
        sxData: ["子鼠", "丑牛", "寅虎", "卯兔", "辰龙", "巳蛇", "午马", "未羊", "申猴", "酉鸡", "戌狗", "亥猪"]
    },
    mutations: {
        getMutationsData (state, data) {
            state[data.key] = data.val;
        }
    },
    actions: {
        getActionsData (context, data) {
            context.commit("getMutationsData", data);
        },
    },
    getters: {

    },
    modules: {}
});
//3.导出使用
export default store;



// WEBPACK FOOTER //
// ./src/store/index.js